<template slot="rates" slot-scope="props">
  <tr
    :class="{ 'blue lighten-5': updated, 'green lighten-5': created }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="editRate"
  >
    <td @click.stop>
      <v-checkbox v-model="selected" :color="$store.state.global.pages.rate.color" hide-details></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span v-if="header.type == 'vehicleTypes'">{{ vehicleTypes || "-" }}</span>
      <span
        v-if="header.type == 'date'"
      >{{ makeShortDate(getObjectPath(header.value, rate)) || "-" }}</span>
      <span v-if="header.type == 'time'">{{ makeTime(getObjectPath(header.value, rate)) || "-" }}</span>
      <span
        v-if="header.type == 'num'"
      >{{ displayDecimal(getObjectPath(header.value, rate),header.decimals) || "-" }}</span>
      <span
        v-if="header.type == 'curr' "
      >{{ !!getObjectPath(header.value, rate) ? `$ ${displayDecimal(getObjectPath(header.value, rate),header.decimals)}` : "-" || "" }}</span>
      <span
        v-if="header.type == 'text'"
      >{{ !!getObjectPathRootExists(header.value, rate) ? getObjectPath(header.value, rate) : "-" || "-" }}</span>
      <span v-if="header.type == 'bool'">
        <v-btn
          flat
          icon
          :color="getObjectPath(header.value, rate) ? 'green lighten-3' : 'red lighten-3'"
        >
          <v-icon v-if="getObjectPath(header.value, rate)">check_circle</v-icon>
          <v-icon v-else>highlight_off</v-icon>
        </v-btn>
      </span>
      <span
        v-if="header.type == 'price'"
      >{{ getObjectPath(header.value, rate)+" / "+ getObjectPath(header.unit, rate) || "-" }}</span>

      <!--ACTIONS COLUMN -->
      <div v-if="header.type == 'action'" class="justify-center layout px-0" @click.stop>
        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left v-if="userAuthClass">
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <basic-list-tile title="Edit" icon="edit" :onClick="editRate"></basic-list-tile>
            <v-divider inset></v-divider>
            <basic-list-tile
              color="red lighten-3"
              title="Delete"
              icon="delete"
              :onClick="deleteRateConfirm"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <v-dialog v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{rate.id}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteRate(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  DIALOGS  -->
    <!-- Rate edit dialog -->
    <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-rate @close="editDialog = false" :rate="rate"></edit-rate>
    </v-dialog>
  </tr>
</template>

<script>
import EditRate from "@/components/rates/editRate";
import FormatDates from "@/services/mixins/formatDates";
import Store from "@/store/computed/storeHelpers";
import RateService from "@/services/requests/rateService";

import CreatedUpdatedRows from "@/services/mixins/createdUpdatedRows";
import RowDisplayMethods from "@/services/mixins/rowDisplayMethods";
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  data() {
    return {
      prefix: "rate",
      hover: false,
      editDialog: false,
      detailDialog: false,
      deleteDialog: false,
      actionConfirmationDialog: false,
      docketDialog: false,
      actionsMenu: false,
      currentNotes: "",
      fieldData: {}
    };
  },
  methods: {
    actionComplete() {
      this.fieldData = {};
      this.actionConfirmationDialog = false;
    },
    deleteRate() {
      //var rate = this.activeRate;
      RateService.deleteRate(this.rate.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("rates/deleteFromArrayStateByValue", {
            prop: "rates",
            value: this.rate
          });
          this.snack({ text: "Rate was deleted!", color: "yellow" });
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError();
        });
    },
    editRate() {
      if (!!this.userAuthClass) this.editDialog = true;
    },
    deleteRateConfirm() {
      this.deleteDialog = true;
    },
    viewDocketDialog() {
      this.docketDialog = true;
    },
    confirmUpdateRateField(payload) {
      this.fieldData = payload;
      this.currentNotes = this.rate[payload.notesField];
      this.actionConfirmationDialog = true;
    }
  },
  computed: {
    vehicleTypes() {
      return this.rate.rateVehicleTypes
        .map(item => item.vehicleType.name)
        .join(", ");
    },
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", { value: val, object: this.rate });
      }
    }
    // activeRate() {
    //     return this.rates.filter( rate => {
    //         return rate.id == this.activeRateId;
    //     })[0]
    // },
  },
  props: {
    rate: Object,
    headers: Array,
    value: Boolean
  },
  components: {
    EditRate
    //DocketDisplay,
    //SingleActions,
    //RateDetail,
    //RateDeletePrompt
  }
};
</script>

<style scoped>
.v-input--selection-controls .v-input__slot {
  margin-bottom: 3px;
}
.new {
  border-left: solid 4px;
  border-color: var(--v-success-base) !important;
}
</style>
